import presupuestoPlaneacion from "./presupuestoPlaneacion.png";
import presupuestoDesarrollo from "./presupuestoDesarrollo.png";
import restanteDisponible from "./restanteDisponible.png";
import presupuestoTesting from "./presupuestoTesting.png";
import extrasTrabajadas from "./extrasTrabajadas.png";
import horasPresupuesto from "./horasPresupuesto.png";
import horasConsumidas from "./horasConsumidas.png";
import recursosextras from "./recursosextras.png";
import headerConclued from "./headerConclued.png";
import trabajadas from "./trabajadas.png";
import editbutton from "./editbutton.png";
import webunity from "./webunity.png";
import planning from "./planning.png";
import consumo from "./consumo.png";
import design from "./design.png";
import close from "./close.png";
import art3d from "./art3d.png";

export const iconsDetailsProyect = {
	presupuestoPlaneacion,
	presupuestoDesarrollo,
	restanteDisponible,
	presupuestoTesting,
	extrasTrabajadas,
	horasPresupuesto,
	horasConsumidas,
	recursosextras,
	headerConclued,
	editbutton,
	trabajadas,
	webunity,
	planning,
	consumo,
	design,
	art3d,
	close,
};
